import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SrDollarSign = ({ cy, cx }) => {
  return (
    <svg
      x={cx - 20}
      y={cy - 17}
      width="40"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12066_41950)">
        <circle cx="14.5" cy="14.5" r="14.5" transform="matrix(-1 0 0 1 34 0.5)" fill="white" />
      </g>
      <path
        d="M24.4964 18.609C24.4964 13.2249 17.3691 14.3282 17.3691 11.901C17.3691 11.217 17.9428 10.5991 19.0461 10.5991C20.0611 10.5991 20.7893 10.9522 21.8926 11.7245C22.0691 11.8569 22.2236 11.8348 22.356 11.6362L23.7903 9.89301C23.9226 9.71648 23.9226 9.58409 23.7461 9.42963C22.7973 8.50287 21.694 7.81883 20.348 7.53197V5.8991C20.348 5.70051 20.2156 5.56812 20.017 5.56812H18.1414C17.9428 5.56812 17.8104 5.70051 17.8104 5.8991V7.48784C15.7362 7.88502 14.0151 9.42963 14.0151 11.8348C14.0151 16.8879 21.1424 16.1376 21.1424 18.5428C21.1424 19.5137 20.2156 20.0653 19.1344 20.0653C17.8546 20.0653 16.8837 19.5799 15.7583 18.6531C15.5597 18.4987 15.3832 18.5428 15.2508 18.6973L13.7283 20.3963C13.6179 20.5508 13.6179 20.7052 13.7283 20.8597C14.5668 21.8306 16.0452 22.8236 17.8104 23.1766V24.655C17.8104 24.8536 17.9428 24.986 18.1414 24.986H20.017C20.2156 24.986 20.348 24.8536 20.348 24.655V23.1545C22.5325 22.7353 24.4964 21.2128 24.4964 18.609Z"
        fill="#00A238"
      />
      <defs>
        <filter
          id="filter0_d_12066_41950"
          x="-4.76837e-07"
          y="0.5"
          width="39"
          height="39"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12066_41950" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12066_41950"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

SrDollarSign.propTypes = {
  cy: PropTypes.number.isRequired,
  cx: PropTypes.number.isRequired,
};

SrDollarSign.displayName = 'SrDollarSign';

export default SrDollarSign;
